module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Setup Google Reviews","subTitle":"What\u0027s the name of your business?","businessMissing":"Is your business missing?","createListing":"Create a Google listing","threeDays":"It may take up to 3 business days for Google to review and approve your business."}}')
  delete Component.options._Ctor
}
